
import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const contractPageSkeleton = () => {
  return (
    <div className='pt-4 '>
       <Skeleton  variant="text" width={300} height={60}/>
       <Skeleton  variant="text" width={150} height={40}/>
     <div className='mx-5'>
      <div className='d-flex justify-content-around mt-1'>
      <Skeleton className={'col-3'} variant="text" height={150} />
      <Skeleton className={'col-8'} variant="text"height={150} />
      </div>
      <div className='d-flex justify-content-around mt-1 '>
      <Skeleton className={'col-3 p-3'} variant="text" height={150} />
      <Skeleton className={'col-8'} variant="text"height={150} />
      </div>
      <div className='d-flex justify-content-around mt-1 '>
      <Skeleton className={'col-3 '} variant="text" height={150} />
      <Skeleton className={'col-8'} variant="text"height={150} />
      </div>
      </div>
    </div>
  );
};
export default contractPageSkeleton;